<h2 mat-dialog-title>Categories</h2>
<mat-dialog-content class="mat-typography">
  <app-category [inputSiteId]="siteId"></app-category>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button color="warn" mat-dialog-close>Cancel</button>
</mat-dialog-actions>
